var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "router-link",
        { attrs: { to: { name: "crossOrgTab", params: { tab: "orgs" } } } },
        [_vm._v("<<Back to Organizations List")]
      ),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("h3", [_vm._v("Domain Approval")]),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-sm": "" } },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "", md5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.rules.required], label: "Name" },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { sm2: "", md2: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "", md5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.rules.required], label: "Email" },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm5: "", md5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.rules.required], label: "Domain" },
                        model: {
                          value: _vm.domain,
                          callback: function ($$v) {
                            _vm.domain = $$v
                          },
                          expression: "domain",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            color: "orange",
                            disabled: !_vm.valid,
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._v("Approve")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }